import sensorService from "@/api/sensorService";
import router from '@/router/index';
import { MESSAGES } from '@/utils/constants';
// import { resetSeconds } from "@/utils/date-helpers";
//  import FileSaver from 'file-saver'
import { notifyApiError, notify, notifyError } from '@/utils/notification-helper';

const state = {
    filteredSensors: [],
    newSensor: {},
    loader: false,
    EmployeeErrors: [],
    searchText: null,

}
const getters = {
    getEditSensor: state => state.newSensor,
    getFilteredSensors: state => state.filteredSensors,
    getSensors: (state, getters, rootState,rootGetters ) => rootGetters.getSensors,
    // {
    //     const text = state.searchText ? state.searchText.toUpperCase() : null; 
    //     const sensors = rootState.sensors;
    //     const resultArray = sensors.filter((sensor) => {
    //         if (text) 
    //             return sensor.name.includes(text);
    //         else 
    //             return true;
    //     });
    //     return resultArray;
    // },
};

const actions = {

    async getSensors({ commit,state, rootState }) {
        state.loader = true;
        let facilityId = rootState.selectedFacility ? rootState.selectedFacility.id : 0
        const response = await sensorService.getSensors(facilityId);
        state.loader=false
        commit('setSensors',  response.data.result, { root: true });
        commit('get', { rootSensors: rootState.sensors });
    },

    async getSensor({ commit,state, rootState }, id ) {
        state.loader=true
        let facilityId = rootState.selectedFacility ? rootState.selectedFacility.id : 0
        const response = await sensorService.getSensor(id, facilityId);
        state.loader=false
        commit('get', response.data.result) 
    },
    async addSensor({ commit }, sensor) {
        const response = await sensorService.addSensor(sensor);
        commit('addSensor', response.data.result, { root: true });
    },
    async editSensor({ commit }, sensor) {
        commit('edit', sensor);
    },
    async updateSensor({ commit }, device) {
        const response = await sensorService.updateSensor(state.editId, device)
        commit('updateSensor', response.data.result, { root: true });
    },
    async deleteSensor({ commit }, sensor) {
        await sensorService.deleteSensor(sensor.dataItem.id);
        commit('removeSensor', sensor.dataItem.id, { root: true });
    },
    async uploadTemplate({ dispatch,commit, rootState }, event) {
        let id = rootState.selectedFacility ? rootState.selectedFacility.id : null

        let data = new FormData();
        let file = event.target.files[0];
        // console.log("file", event.target.files[0])
        data.append('name', 'my-file')
        data.append('file', file)

        let config = {
            header: {
                'Content-Type': 'multipart/form-data',
            }
        }
        await sensorService.DriverUploadTemplate(id, data, config).then((res) => {
            state.EmployeeErrors = []
            let resData = res.data.templateErrorMessage
            if (resData.length != 0) {
                notifyError(MESSAGES.RESOLVE_ERRORS)
                 commit("employeeError", resData)
            }
            else {
                notify(MESSAGES.TEMPLATE_UPLOAD_SUCCESS)
                dispatch('getDriver');
            }
        }).catch((err) => {
            notifyApiError(err)
        })
    }
}
const mutations = {
    get(state, values) {
        if (!state.searchText)
            state.filteredSensors = values.rootSensors;
        else {
            const text = state.searchText.toUpperCase();
            const resultArray = values.rootSensors.filter((sensor) => {
                if (text) 
                    return sensor.name.includes(text);
                else 
                    return true;
            });
            return resultArray;
        }
    },
    add(state, newSensor) {
        state.devices.push(newSensor);
        state.metadata = {}
    },
    edit(state, sensor) {
        state.editId = sensor.id
        state.newSensor = sensor
        state.metadata = sensor.metaData ? sensor.metaData : {}
        router.push({ name: "sensorAddUpdate", params: { add: false } });
    },
    update(state, sensor) {
        const index = state.sensors.map(item => item.di).indexOf(sensor.code)
        state.sensors[index] = sensor;
        state.metadata = {}
    },
    delete(state, sensor) {
        var sensors = state.sensors;
        const index = sensors.map(item => item.id).indexOf(sensor.id);
        sensors.splice(index, 1);
    },
    getFile(state, item) {
        if (item == 'Data not available') {
            state.driverFileList = []
        }
        else {
            state.driverFileList = item

        }

    },
    employeeError(state, data) {
    //    console.log("error",data)
        data.map(data => {
            if (data.error) {
                state.EmployeeErrors.push({ error: data.error, email: data.notAddedEmployee.emailID, empID: data.notAddedEmployee.employeeCode, empName: data.notAddedEmployee.name, })
            }
            else {
                state.EmployeeErrors.push({ error: data.errorMessage, cell: data.cell })
            }
        })
    },
    downloadData(){

    },
    cancel(state) {

        state.metadata = {}
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}